import { capitalize } from "lodash";

export default function (values: Record<string, any>) {
  return Object.values(values).map((item) => ({
    label: capitalize(item),
    value: item,
  }));
}
